import { render, staticRenderFns } from "./OverviewCards.vue?vue&type=template&id=db46fe06&scoped=true"
import script from "./OverviewCards.vue?vue&type=script&lang=js"
export * from "./OverviewCards.vue?vue&type=script&lang=js"
import style0 from "./OverviewCards.vue?vue&type=style&index=0&id=db46fe06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db46fe06",
  null
  
)

export default component.exports